import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppThunk, RootState} from "../../app/store";
import {saveToLocalStorage} from "../storage/localStorage";

export interface YogaExercise {
    workoutPeriod: number;
    sleepPeriod: number;
    counter: number;
    backgroundAudio: string;
    status: 'idle' | 'workout';
}

export const yogaInitialState: YogaExercise = {
    workoutPeriod: 30,
    sleepPeriod: 10,
    counter: 0,
    backgroundAudio: 'https://www.youtube.com/watch?v=fozyNJuasgA',
    status: 'idle',
};

export const yogaSlice = createSlice({
    name: 'yogaCounter',
    initialState: yogaInitialState,
    reducers: {
        increaseCounter: (state) => {
            state.counter += 1
        },
        setWorkoutPeriod: (state, action: PayloadAction<number>) => {
            state.workoutPeriod = action.payload;
        },
        setSleepPeriod: (state, action: PayloadAction<number>) => {
            state.sleepPeriod = action.payload;
        },
        setBackgroundAudio: (state, action: PayloadAction<string>) => {
            state.backgroundAudio = action.payload;
        },
        startWorkout: (state) => {
            state.counter = 0
            state.status = 'workout'
        },
        endWorkout: (state) => {
            state.status = 'idle'
        },
    }
});

export const {
    setWorkoutPeriod,
    setSleepPeriod,
    startWorkout,
    endWorkout,
    increaseCounter,
    setBackgroundAudio
} = yogaSlice.actions;
export const selectWorkoutPeriod = (state: RootState) => state.yoga.workoutPeriod;
export const selectBackgroundAudio = (state: RootState) => state.yoga.backgroundAudio;
export const selectSleepPeriod = (state: RootState) => state.yoga.sleepPeriod;
export const selectStatus = (state: RootState) => state.yoga.status;
export const selectCounter = (state: RootState) => state.yoga.counter;
export const switchStatus = (): AppThunk => (
    dispatch,
    getState
) => {
    const rootState = getState();
    const currentStatus = selectStatus(rootState);
    if (currentStatus === 'idle') {
        saveToLocalStorage({
            workoutPeriod: selectWorkoutPeriod(rootState),
            sleepPeriod: selectSleepPeriod(rootState),
            backgroundAudio: selectBackgroundAudio(rootState)
        });
        dispatch(startWorkout());
        dispatch(countTime())
    } else {
        dispatch(endWorkout())
    }
};
export const countTime = (): AppThunk => (
    dispatch,
    getState
) => {
    const currentStatus = selectStatus(getState());
    if (currentStatus === 'workout') {
        dispatch(increaseCounter());
        setTimeout(() => {
            dispatch(countTime());
        }, 1000);
    }
};

export default yogaSlice.reducer;
